// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"14d6bbaf","49":"63060f14","159":"971fc081","213":"f61d8097","240":"e6dbda78","551":"8a167b5e","585":"87cbc6ef","649":"4151d88c","826":"a435db52","946":"0e729e45","959":"c7f4f35c"}[chunkId] + ".chunk.js";
};